import React from 'react';
import { useSelector } from 'react-redux';
import VideoComponent from '../components';

const VideoPageContainer = () => {
  console.log('VideoPageContainer');
  const { userList, isProcessing } = useSelector((state) => state.homeReducers);
  const { token, userInfor } = useSelector((state) => state.authReducers);
  return <VideoComponent />;
};

export default VideoPageContainer;
